<script setup lang="ts">
/*
 * FILE: unified_ui/src/components/ThemeToggle.vue
 * PURPOSE: 2-state theme toggle button (light <-> dark). Sun icon shown
 *          when current theme is dark (clicking switches to light); moon
 *          icon shown when current theme is light (clicking switches to
 *          dark). Same footprint as before the polish plan.
 * OWNS: theme toggle button UI
 * EXPORTS: ThemeToggle component
 * DOCS: docs/architecture/components/core.md
 */
import { computed } from 'vue'
import { useThemeStore } from '@/stores/theme'

const theme = useThemeStore()

const ariaLabel = computed(() =>
  theme.isDark ? 'Включить светлую тему' : 'Включить тёмную тему',
)
const title = computed(() =>
  theme.isDark
    ? 'Тема: тёмная. Нажмите — переключить на светлую.'
    : 'Тема: светлая. Нажмите — переключить на тёмную.',
)
</script>

<template>
  <button
    type="button"
    class="flex h-9 w-9 items-center justify-center rounded-xl text-ink-500 transition-colors hover:bg-ink-100/60 hover:text-ink-700 dark:text-slate-400 dark:hover:bg-slate-700/60 dark:hover:text-slate-200"
    :title="title"
    :aria-label="ariaLabel"
    @click="theme.toggle()"
  >
    <!-- Sun icon (Ionicons sunny-outline) — shown in dark mode, click to go light -->
    <svg
      v-if="theme.isDark"
      class="h-5 w-5"
      viewBox="0 0 512 512"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="32"
    >
      <path d="M256 48v48M256 416v48M403.08 108.92l-33.94 33.94M142.86 369.14l-33.94 33.94M464 256h-48M96 256H48M403.08 403.08l-33.94-33.94M142.86 142.86l-33.94-33.94" />
      <circle cx="256" cy="256" r="80" />
    </svg>
    <!-- Moon icon (Ionicons moon-outline) — shown in light mode, click to go dark -->
    <svg
      v-else
      class="h-5 w-5"
      viewBox="0 0 512 512"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    >
      <path d="M160 136c0-30.62 4.51-61.61 16-88C99.57 81.27 48 159.32 48 248c0 119.29 96.71 216 216 216 88.68 0 166.73-51.57 200-128-26.39 11.49-57.38 16-88 16-119.29 0-216-96.71-216-216" />
    </svg>
  </button>
</template>
